import { ACTIVITY_STATES } from 'constants/enums'
import { groupBy, get } from 'lodash'

const mayMajorStates = [
  ACTIVITY_STATES.in_progress.id,
  ACTIVITY_STATES.waiting_for_approval.id
]
const isDoneStates = [
  ACTIVITY_STATES.complete.id,
  ACTIVITY_STATES.replaced.id,
  ACTIVITY_STATES.ceremony.id,
  ACTIVITY_STATES.office_signoff.id
]

export default function(activities) {
  const major = activities ? activities.find(activity => activity.isMajor) : {}

  const mayBeMajor = activities
    ? activities.filter(activity =>
        mayMajorStates.includes(get(activity, 'activityState.value'))
      )
    : []

  const isMajorDone =
    major && isDoneStates.includes(get(major, 'activityState.value'))

  const mayBeMajorGrouped = groupBy(mayBeMajor, activity =>
    get(activity, 'activitySection.value')
  )

  return {
    isMajorDone,
    mayBeMajor,
    mayBeMajorGrouped,
    major
  }
}
